import { render, staticRenderFns } from "./BaseChartTeste.vue?vue&type=template&id=4a7cce54&"
import script from "./BaseChartTeste.vue?vue&type=script&lang=js&"
export * from "./BaseChartTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports